"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_BASE = "https://api.nomics.com";
var IntervalEnum;
(function (IntervalEnum) {
    IntervalEnum["Minute"] = "1m";
    IntervalEnum["Hour"] = "1h";
    IntervalEnum["Day"] = "1d";
    IntervalEnum["Week"] = "7d";
    IntervalEnum["Month"] = "30d";
    IntervalEnum["YearToDate"] = "ytd";
    IntervalEnum["Year"] = "365d";
    IntervalEnum["All"] = "all";
})(IntervalEnum = exports.IntervalEnum || (exports.IntervalEnum = {}));
//# sourceMappingURL=constants.js.map